export default "src/content/themes/association-wordpress-theme/img/175e505d62a1436954205e1619ddde22.png";